<template>
  <div class="kehufengxiandengjiceping-index">
    <div class="header">
      <div class="logo">
        <div class="imgs">
          <img src="@/assets/robot.png" alt="客户风险等级测评">
        </div>
        <h1>客户风险等级测评</h1>
      </div>
    </div>

    <div class="content">
      <div class="card">
        <div class="card-header">
          <div class="header-left">
            <div class="imgs2">
              <img src="@/assets/kehufengxian/answer.png">
            </div>
            <h2 v-if="currentQuestion && currentQuestion.category === 'basic'">基础信息</h2>
            <h2 v-if="currentQuestion && currentQuestion.category === 'financial'">财务信息</h2>
            <h2 v-if="currentQuestion && currentQuestion.category === 'investment'">投资信息</h2>
          </div>
          <div class="header-right">
            第 {{ currentQuestionIndex + 1 }} 题/共 {{ questions.length }} 题
          </div>
        </div>

        <div class="question-section">
          <div class="question" v-if="currentQuestion">
            <div>
              <span class="question-number">{{ currentQuestion.id }}：</span>
              <span class="question-text">{{ currentQuestion.text }}</span>
            </div>
            <button class="play-btn" id="btn-play-speech" @click="toggleSpeech" :class="{ 'playing': isPlaying }"
                    title="播放语音">
              <svg v-if="!isPlaying" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5v14l11-7z" fill="currentColor" />
              </svg>
              <svg v-else viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" fill="currentColor" />
              </svg>
            </button>
          </div>

          <div class="options" v-if="currentQuestion && currentQuestion.options">
            <div class="options-hint" v-if="currentQuestion.type === 'multiple'">
              <i class="el-icon-info"></i> 多选题（可多选）
            </div>
            <div v-for="(option, index) in currentQuestion.options" :key="index" :class="['option-item', {
              active: currentQuestion.type === 'multiple'
                ? selectedOptions.includes(index)
                : selectedOption === index
            }]" @click="selectOption(index)">
              <span v-if="currentQuestion.type !== 'multiple'" class="option-label">{{ option.key }}</span>
              <span v-else :class="['option-checkbox', { checked: selectedOptions.includes(index) }]">
                <i v-if="selectedOptions.includes(index)" class="el-icon-check"></i>
              </span>
              <span class="option-text">{{ option.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="next-btn common-btn" id="btn-next-question" @click="handleNext" :disabled="!canGoNext">
        {{ isLastQuestion ? '提交' : '下一题' }} <i class="el-icon-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import apiOpen from '@/api/open.js'
import Broadcast from './broadcast.js'
export default {
  name: 'KehufengxiandengjicepingIndex',
  data () {
    return {
      // studentId: '',
      // version: window.version,
      currentQuestionIndex: 0,
      selectedOption: null,
      selectedOptions: [], // 多选题选中的选项索引
      questions: [],
      answers: {}, // 存储所有问题的答案
      // 语音播放相关
      isPlaying: false,
      showAutoPlayTip: true,
      showErrorTip: false,
      errorMessage: '',
      broadcast: null,
      hasAutoPlayed: false,
      isSpeaking: false, // 播放锁
    }
  },
  computed: {
    currentQuestion () {
      return this.questions[this.currentQuestionIndex]
    },
    isLastQuestion () {
      return this.currentQuestionIndex === this.questions.length - 1
    },
    canGoNext () {
      if (!this.currentQuestion) return false
      if (this.currentQuestion.type === 'multiple') {
        return this.selectedOptions.length > 0
      }
      return this.selectedOption !== null
    }
  },
  created () {
    // 优先从 localStorage 获取问题数据（支持跨标签页共享）
    let questionsStr = localStorage.getItem('questions')

    // 如果 localStorage 没有，尝试从 sessionStorage 获取
    if (!questionsStr) {
      questionsStr = sessionStorage.getItem('questions')
    }

    this.questions = questionsStr ? JSON.parse(questionsStr) : []

    // 如果没有问题数据，跳转到说明页面加载数据
    if (this.questions.length === 0) {
      this.$router.push({ name: 'Cepingsm' })
      return
    }

    // 安全获取 userinfo，优先从 localStorage 获取（支持跨标签页共享）
    let userinfoStr = localStorage.getItem('userinfo')
    if (!userinfoStr) {
      userinfoStr = sessionStorage.getItem('userinfo')
    }
    // const userinfo = userinfoStr ? JSON.parse(userinfoStr) : null
    // this.studentId = userinfo?.id || ''

    // 初始化文字播报
    this.broadcast = new Broadcast()

    // 检查是否从附加题页面返回
    const followUpSelected = localStorage.getItem('followUpSelected')
    if (followUpSelected !== null) {
      const savedIndex = localStorage.getItem('followUpQuestionIndex')
      if (savedIndex !== null) {
        this.currentQuestionIndex = parseInt(savedIndex, 10)
      }

      // 从 localStorage 恢复之前已保存的答题状态（含本次附加题关联题目的答案）
      const savedState = localStorage.getItem('quizState')
      if (savedState) {
        try {
          const state = JSON.parse(savedState)
          this.answers = state.answers || {}
        } catch (e) {
          console.error('恢复 quizState 失败', e)
        }
      }

      localStorage.removeItem('followUpData')
      localStorage.removeItem('followUpQuestionIndex')
      if (followUpSelected === 'cancel') {
        // 取消附加题 - 回到离开时的题目，不走下一题
        this.restoreQuestionState()
        localStorage.removeItem('followUpSelected')
      } else {
        // 附加题已确认 - 进入下一题
        localStorage.removeItem('followUpSelected')
        this.goToNextQuestion()
      }
      return
    }

    // 监听播报状态
    this.broadcast.audioPlayer.onPlay = () => {
      console.log('开始播报')
      this.isPlaying = true
      this.showAutoPlayTip = false
    }

    this.broadcast.audioPlayer.onStop = () => {
      console.log('结束播报')
      this.isPlaying = false
      this.isSpeaking = false // 释放播放锁
    }
  },
  mounted () {
    const handleFirstClick = () => {
      if (!this.hasAutoPlayed && !this.isPlaying) {
        this.hasAutoPlayed = true
        this.speakQuestion()
      }
      document.removeEventListener('click', handleFirstClick)
    }
    document.addEventListener('click', handleFirstClick)

    // 添加 localStorage 变化监听（用于接收主屏的操作同步）
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy () {
    this.stopSpeech()
    // 移除 localStorage 监听
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    // 切换语音播放/停止
    toggleSpeech () {
      if (this.isPlaying) {
        this.stopSpeech()
      } else {
        this.speakQuestion()
      }
    },
    // 停止语音播报
    stopSpeech () {
      console.log('停止播报，isPlaying:', this.isPlaying)
      if (this.broadcast) {
        this.broadcast.stop()
      }
      this.isPlaying = false
      this.isSpeaking = false // 释放播放锁
      console.log('停止播报完成，isPlaying:', this.isPlaying, 'isSpeaking:', this.isSpeaking)
    },
    // 播报当前题目
    speakQuestion () {
      // 如果正在播放，直接返回（防止重复调用）
      if (this.isSpeaking) {
        console.log('正在播放中，忽略重复调用')
        return
      }

      // 设置播放锁
      this.isSpeaking = true

      // 强制停止之前的播放
      console.log('speakQuestion 被调用，当前索引:', this.currentQuestionIndex)
      this.stopSpeech()

      const question = this.currentQuestion
      let text = '第' + (this.currentQuestionIndex + 1) + '题，' + question.text + '。'

      // 暂时屏蔽选项播报，因为选项数量未知，导致播报时间过长
      // question.options.forEach((option) => {
      //   // text += option.key + '、' + option.text + '。'
      //   text += option.key + '、' + option.text.replace(/\s+/g, '') + '[p500]'
      // })
      console.log("播报文本:", text)
      console.log("题目选项数量:", question.options.length)

      // 延迟一下再播放，确保停止操作完成
      setTimeout(() => {
        this.speakWithXfyun(text)
      }, 100)
    },
    // 使用讯飞语音合成播报
    speakWithXfyun (text) {
      console.log('speakWithXfyun 被调用，文本长度:', text.length)
      if (!window.broadcastConfig) {
        this.showErrorTip = true
        this.errorMessage = '未找到讯飞配置，请检查 ProjectConfig.js'
        return
      }

      this.showAutoPlayTip = false
      this.showErrorTip = false

      // 配置发音人
      const vcn = window.broadcastConfig.dub || 'xiaoyan'

      console.log('准备调用 broadcast.play，发音人:', vcn)
      // 使用 Broadcast 类播放
      this.broadcast.play({
        text: text,
        vcn: vcn
      })
    },


    selectOption (index) {
      const isMultiple = this.currentQuestion && this.currentQuestion.type === 'multiple'

      if (isMultiple) {
        // 多选题：切换选中状态
        const idx = this.selectedOptions.indexOf(index)
        if (idx > -1) {
          this.selectedOptions.splice(idx, 1)
        } else {
          this.selectedOptions.push(index)
        }
        // 强制刷新
        this.selectedOptions = [...this.selectedOptions]
      } else {
        // 单选题
        this.selectedOption = index
      }

      // 同步当前状态到 localStorage（用于主副屏同步）
      const state = {
        currentQuestionIndex: this.currentQuestionIndex,
        selectedOption: this.selectedOption,
        selectedOptions: this.selectedOptions,
        answers: this.answers
      }
      localStorage.setItem('quizState', JSON.stringify(state))
    },
    handleNext () {
      const isMultiple = this.currentQuestion && this.currentQuestion.type === 'multiple'
      if (isMultiple) {
        if (this.selectedOptions.length === 0) {
          this.$message.warning('请至少选择一个选项');
          return
        }
      } else {
        if (this.selectedOption === null) {
          this.$message.warning('请选择一个选项');
          return
        }
      }

      // 保存当前问题的答案
      const currentQuestion = this.questions[this.currentQuestionIndex]
      if (isMultiple) {
        this.answers[currentQuestion.id] = {
          optionIndices: [...this.selectedOptions],
          answer: currentQuestion.options
            .filter((_, i) => this.selectedOptions.includes(i))
            .map(o => o.key)
            .join(','),
          score: currentQuestion.options
            .filter((_, i) => this.selectedOptions.includes(i))
            .reduce((max, o) => Math.max(max, o.score || 0), 0)
        }
      } else {
        this.answers[currentQuestion.id] = {
          optionIndex: this.selectedOption,
          answer: currentQuestion.options[this.selectedOption].key,
          score: currentQuestion.options[this.selectedOption].score
        }
      }

      if (this.isLastQuestion) {
        this.submit()
      } else if (currentQuestion.followUp) {
        // 判断是否选了 A（第一个选项）
        const selectedA = isMultiple
          ? this.selectedOptions.includes(0)
          : this.selectedOption === 0
        if (selectedA) {
          console.log("currentQuestion.followUp>>>", currentQuestion.followUp)
          // 选了 A 才有附加题 - 跳转到新页面
          // 导航前保存当前答题状态到 localStorage，避免组件重建后 answers 丢失
          const state = {
            currentQuestionIndex: this.currentQuestionIndex,
            selectedOption: this.selectedOption,
            selectedOptions: this.selectedOptions,
            answers: this.answers
          }
          localStorage.setItem('quizState', JSON.stringify(state))
          localStorage.setItem('followUpData', currentQuestion.followUp)
          localStorage.setItem('followUpQuestionIndex', String(this.currentQuestionIndex))
          this.$router.push({ name: 'CepingFuwuti' })
        } else {
          // 没选 A 直接进入下一题
          this.goToNextQuestion()
        }
      } else {
        // 进入下一题
        this.currentQuestionIndex++
        // 恢复下一题的答案状态
        const nextQuestion = this.questions[this.currentQuestionIndex]
        const saved = this.answers[nextQuestion.id]
        if (saved) {
          if (nextQuestion.type === 'multiple') {
            this.selectedOptions = saved.optionIndices ? [...saved.optionIndices] : []
          } else {
            this.selectedOption = saved.optionIndex
          }
        } else {
          this.selectedOption = null
          this.selectedOptions = []
        }

        // 同步当前状态到 localStorage（用于主副屏同步）
        const state = {
          currentQuestionIndex: this.currentQuestionIndex,
          selectedOption: this.selectedOption,
          selectedOptions: this.selectedOptions,
          answers: this.answers
        }
        localStorage.setItem('quizState', JSON.stringify(state))

        this.stopSpeech()

        // 切换到下一题后自动播报
        setTimeout(() => {
          this.speakQuestion()
        }, 100)
      }
    },
    // 提交测评
    submit () {
      // 保存最后一题的答案
      const currentQuestion = this.questions[this.currentQuestionIndex]
      const isMultiple = currentQuestion && currentQuestion.type === 'multiple'
      if (isMultiple) {
        this.answers[currentQuestion.id] = {
          optionIndices: [...this.selectedOptions],
          answer: currentQuestion.options
            .filter((_, i) => this.selectedOptions.includes(i))
            .map(o => o.key)
            .join(','),
          score: currentQuestion.options
            .filter((_, i) => this.selectedOptions.includes(i))
            .reduce((max, o) => Math.max(max, o.score || 0), 0)
        }
      } else {
        this.answers[currentQuestion.id] = {
          optionIndex: this.selectedOption,
          answer: currentQuestion.options[this.selectedOption].key,
          score: currentQuestion.options[this.selectedOption].score
        }
      }

      // 这里可以添加提交测评的逻辑
      let answers = []
      for (let i = 0; i < this.questions.length; i++) {
        const question = this.questions[i]
        const questionAnswer = this.answers[question.id]

        if (questionAnswer) {


          if (question.followUp) {
            answers.push({
              id: question.id,
              answer: questionAnswer.answer,
              score: questionAnswer.score,
              followUpAnswer: 'A'
            })
          } else {
            answers.push({
              id: question.id,
              answer: questionAnswer.answer,
              score: questionAnswer.score
            })
          }
        }
      }
      let data = {
        // "studentId": this.studentId,
        "answers": answers
      }

      // apiOpen.RiskType(data).then(res => {
      //   console.log("提交测评成功：", res)
      //   // 存储测评结果（同时存储到 sessionStorage 和 localStorage，支持跨标签页共享）
      //   sessionStorage.setItem('riskResult', JSON.stringify(res))
      //   localStorage.setItem('riskResult', JSON.stringify(res))
      //   // 这里可以添加开始测评的逻辑
      //   // 提交测评
      //   this.$message.success('测评提交成功！');
      //   // 这里可以添加提交测评的逻辑
      //   this.$router.push({ name: 'CepingJieguo' });
      // }).catch(err => {
      //   console.log(err)
      //   this.$message.error(err)
      // })

      apiOpen.VisitorRiskType(data).then(res => {
        console.log("提交测评成功：", res)
        // 存储测评结果（同时存储到 sessionStorage 和 localStorage，支持跨标签页共享）
        sessionStorage.setItem('riskResult', JSON.stringify(res))
        localStorage.setItem('riskResult', JSON.stringify(res))
        // 这里可以添加开始测评的逻辑
        // 提交测评
        this.$message.success('测评提交成功！');
        // 这里可以添加提交测评的逻辑
        this.$router.push({ name: 'CepingJieguo' });
      }).catch(err => {
        console.log(err)
        this.$message.error(err)
      })

    },

    goToNextQuestion () {
      // 进入下一题
      this.currentQuestionIndex++
      this.restoreQuestionState()

      this.stopSpeech()

      // 切换到下一题后自动播报
      setTimeout(() => {
        this.speakQuestion()
      }, 100)
    },
    restoreQuestionState () {
      // 根据 currentQuestionIndex 恢复已选的答案状态
      const question = this.questions[this.currentQuestionIndex]
      if (!question) return
      const saved = this.answers[question.id]
      if (saved) {
        if (question.type === 'multiple') {
          this.selectedOptions = saved.optionIndices ? [...saved.optionIndices] : []
        } else {
          this.selectedOption = saved.optionIndex
        }
      } else {
        this.selectedOption = null
        this.selectedOptions = []
      }

      // 同步当前状态到 localStorage（用于主副屏同步）
      const state = {
        currentQuestionIndex: this.currentQuestionIndex,
        selectedOption: this.selectedOption,
        selectedOptions: this.selectedOptions,
        answers: this.answers
      }
      localStorage.setItem('quizState', JSON.stringify(state))
    },

    /**
     * 处理 localStorage 变化事件（用于接收主屏的操作同步）
     */
    handleStorageChange (event) {
      const { key, newValue } = event

      // 只处理 quizState 的变化
      if (key === 'quizState' && newValue !== null) {
        try {
          const state = JSON.parse(newValue)

          // 更新当前题目索引
          this.currentQuestionIndex = state.currentQuestionIndex

          // 更新选中的选项
          this.selectedOption = state.selectedOption !== undefined ? state.selectedOption : null
          this.selectedOptions = state.selectedOptions ? [...state.selectedOptions] : []

          // 更新答案
          if (state.answers) {
            this.answers = { ...this.answers, ...state.answers }
          }

          console.log('收到主屏同步：第', state.currentQuestionIndex + 1, '题，选项', state.selectedOption)
        } catch (e) {
          console.error('Failed to parse quiz state:', e)
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.kehufengxiandengjiceping-index {
  min-height: 100vh;
  // background: linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 50%, #f5f0ff 100%);
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 60px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.header {
  margin-bottom: 40px;
  text-align: center;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.imgs {
  width: 48px;
  height: 48px;
  border-radius: 36%;
  background: #4779f4;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 28px;
    height: 28px;
    object-fit: cover;
  }
}

.imgs2 {
  width: 36px;
  height: 36px;
  border-radius: 36%;
  background: #4779f4;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 22px;
    height: 22px;
    object-fit: cover;
  }
}

.logo i {
  font-size: 32px;
  color: #3b82f6;
  background: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
}

.logo h1 {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.content {
  width: 100%;
  max-width: 600px;
  margin-bottom: 60px;
}

.card {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-left i {
  font-size: 20px;
  color: #3b82f6;
}

.header-left h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.header-right {
  font-size: 14px;
  color: #64748b;
}

.question-section {
  margin-top: 24px;
}

.question {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  font-size: 16px;
  color: #1e293b;
  line-height: 1.5;
}

.play-btn {
  width: 40px;
  height: 40px;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.play-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.play-btn.playing {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  animation: pulse 1.5s infinite;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }
}

.play-btn svg {
  width: 20px;
  height: 20px;
  color: white;
}


.question-number {
  font-weight: 600;
  color: #3b82f6;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.options-hint {
  font-size: 13px;
  color: #6366f1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #e0e7ff 0%, #f0e7ff 100%);
  border-radius: 8px;
  margin-bottom: 4px;
}

.options-hint i {
  font-size: 14px;
}

.option-checkbox {
  width: 22px;
  height: 22px;
  border: 2px solid #cbd5e1;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
  background: white;
}

.option-checkbox.checked {
  background: #6366f1;
  border-color: #6366f1;
}

.option-checkbox.checked i {
  color: white;
  font-size: 12px;
  font-weight: 700;
}

.option-checkbox i {
  color: transparent;
  font-size: 12px;
  transition: all 0.2s ease;
}

.option-item.active .option-checkbox {
  border-color: #6366f1;
}

.option-item.active .option-checkbox:not(.checked) {
  background: #e0e7ff;
}

.option-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.option-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.option-item.active {
  border-color: #3b82f6;
  background: #e0e7ff;
  color: #3b82f6;
}

.option-label {
  width: 24px;
  height: 24px;
  background: #f1f5f9;
  color: #64748b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.option-item.active .option-label {
  background: #3b82f6;
  color: white;
}

.option-text {
  font-size: 14px;
  color: #1e293b;
}

.option-item.active .option-text {
  color: #3b82f6;
  font-weight: 500;
}

.footer {
  width: 100%;
  max-width: 600px;
}

.next-btn {
  width: 100%;
  font-size: 18px;
  position: relative;
}

.next-btn:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.next-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
}



/* 横屏适配 */
@media screen and (orientation: landscape) and (max-width: 1366px) {
  .kehufengxiandengjiceping-index {
    padding: 30px 60px;
  }

  .logo i {
    font-size: 40px;
    width: 80px;
    height: 80px;
  }

  .logo h1 {
    font-size: 36px;
  }

  .content {
    max-width: 700px;
    margin-bottom: 40px;
  }

  .card {
    padding: 40px;
  }

  .header-left h2 {
    font-size: 24px;
  }

  .header-left i {
    font-size: 24px;
  }

  .header-right {
    font-size: 16px;
  }

  .question {
    font-size: 18px;
    margin-bottom: 32px;
  }

  .options {
    gap: 16px;
  }

  .option-item {
    padding: 10px;
  }

  .option-label {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }

  .option-text {
    font-size: 16px;
  }

  .next-btn {
    padding: 20px;
    font-size: 20px;
  }

  .next-btn::after {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .kehufengxiandengjiceping-index {
    padding: 20px 16px;
    min-height: 100vh;
    // background: linear-gradient(180deg, #f0f4ff 0%, #faf5ff 50%, #f0f9ff 100%);
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
  }

  .header {
    margin-bottom: 0;
    text-align: center;
    padding-top: 10px;
  }

  .logo {
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }

  .logo .imgs {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    // box-shadow: 0 6px 20px rgba(99, 102, 241, 0.3);
    // background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  }

  .logo .imgs img {
    width: 28px;
    height: 28px;
  }

  .logo h1 {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    letter-spacing: 0.5px;
    // background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // background-clip: text;
    margin: 0;
  }

  .content {
    max-width: 100%;
    width: 100%;
    margin-bottom: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .card {
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(99, 102, 241, 0.08);
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .card-header {
    margin-bottom: 20px;
    gap: 10px;
    padding-bottom: 16px;
    border-bottom: 1px dashed #e2e8f0;
    flex-wrap: wrap;
    align-items: center;
  }

  .header-left {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .header-left .imgs2 {
    width: 32px;
    height: 32px;
    // background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
  }

  .header-left .imgs2 img {
    width: 18px;
    height: 18px;
  }

  .header-left h2 {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
  }

  .header-right {
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
  }

  .question-section {
    display: flex;
    flex-direction: column;
    gap: 14px;
    flex: 1;
    justify-content: flex-start;
  }

  .question {
    font-size: 15px;
    line-height: 1.5;
    padding: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 10px;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 0;
  }

  .question-number {
    // color: #6366f1;
    font-weight: 600;
    flex-shrink: 0;
  }

  .question-text {
    color: #1e293b;
    font-weight: 500;
    flex: 1;
  }

  .play-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    flex-shrink: 0;
    transition: all 0.2s ease;
  }

  .play-btn:hover {
    transform: scale(1.05);
  }

  .play-btn.playing {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  }

  .options {
    gap: 10px;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-start;
  }

  .option-item {
    padding: 12px 14px;
    border-radius: 10px;
    background: white;
    border: 2px solid #e2e8f0;
    transition: all 0.2s ease;
    flex-wrap: wrap;
    gap: 8px;
  }

  .option-item:hover {
    // border-color: #6366f1;
    // background: #f8fafc;
  }

  .option-item.active {
    // border-color: #6366f1;
    // background: linear-gradient(135deg, #f0f4ff 0%, #e0e7ff 100%);
    // box-shadow: 0 4px 12px rgba(99, 102, 241, 0.15);
  }

  .option-label {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-size: 14px;
    font-weight: 600;
    background: #e2e8f0;
    color: #64748b;
    flex-shrink: 0;
  }

  .option-item.active .option-label {
    // background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    // color: white;
  }

  .option-text {
    font-size: 14px;
    color: #334155;
  }

  .option-item.active .option-text {
    color: #1e293b;
    font-weight: 500;
  }

  .footer {
    display: none;
    max-width: 100%;
  }

  .next-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    // background: linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #7c3aed 100%);
    // border: none;
    // color: white;
    // box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
  }

  .next-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }

  .next-btn:hover:not(:disabled)::before {
    left: 100%;
  }

  .next-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }

  .next-btn:disabled {
    background: #cbd5e1;
    box-shadow: none;
    cursor: not-allowed;
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .kehufengxiandengjiceping-index {
    padding: 32px 16px;
  }

  .logo i {
    font-size: 24px;
    width: 48px;
    height: 48px;
  }

  .logo h1 {
    font-size: 20px;
  }

  .card {
    padding: 20px;
    border-radius: 12px;
  }

  .header-left h2 {
    font-size: 16px;
  }

  .header-left i {
    font-size: 16px;
  }

  .header-right {
    font-size: 12px;
  }

  .question {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .options {
    gap: 10px;
  }

  .option-item {
    padding: 12px;
    border-radius: 8px;
  }

  .option-label {
    width: 20px;
    height: 20px;
    font-size: 12px;
  }

  .option-text {
    font-size: 12px;
  }

  .next-btn {
    padding: 12px;
    font-size: 14px;
    border-radius: 8px;
  }

  .next-btn::after {
    width: 20px;
    height: 20px;
    font-size: 10px;
  }
}
</style>
